import React from 'react';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import {Box, Grid, Button, Typography} from "@material-ui/core";
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Image from "next/image";

const useStyles = makeStyles((theme) => ({
  videoStyles: {
    paddingRight: '.75rem',
    border: 0,
  },
  imgStyles: {
    maxHeight: '480px',
    height: '100%',
    padding: 40,
  },
  iconStyles: {
    padding: '15px 15px 0 0',
    marginLeft: 'auto',
    width: '1.5em',
    height: '1.5em'
  },
  modalStyles: {
    '& .MuiDialog-paper': {
      minWidth: '900px',
      [theme.breakpoints.down('sm')]: {
        minWidth: '500px',
      },
    },
  },
  gridStyles: {
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
    },
  },
  titleStyles: {
    '& h2': {
      fontSize: '28px',
      textAlign: 'center'
    },
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  buttonStyles: {
    padding: 0
  }
  }),
);

const AerialGolfHole = (props) => {
  let {ytSource, imgSource} = props;
  const classes = useStyles(props);

  const [open, setOpen] = React.useState(false);
  let videoEmbed = ytSource;
  // Format for embedding YouTube video:
  if (ytSource?.includes('https://youtu.be')) {
    videoEmbed = ytSource.replace('https://youtu.be', 'https://youtube.com/embed');
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box py={4}>
      <Grid container className={classes.gridStyles} justifyContent="center" alignItems="stretch">
        <Grid item md={9}>
          {ytSource &&
          <CardMedia className={classes.videoStyles} component='iframe' src={videoEmbed} height='100%' title='Golf hole video' />
          }
          {!ytSource &&
            <Typography component={`p`} variant={`body1`}>
              We have an aerial video coming out soon to present an overview of this course.
            </Typography>
          }
        </Grid>
        <Grid item md={3}>
          {imgSource &&
          <Box display={`flex`} justifyContent="flex-end">
            <Button className={classes.buttonStyles} onClick={handleClickOpen}>
              <Box border='1px solid #3C8047' width="220px" height="440px" display='flex' flexDirection='column'>
                <SearchIcon color='primary' className={classes.iconStyles}/>
                  <Box p={5}>
                  <Image width="190" height="360" layout="fill" objectFit="contain" className={classes.imgStyles} src={imgSource} alt='Alt Text'/>
                  </Box>
              </Box>
            </Button>
          </Box>
          }
        </Grid>
      </Grid>
      <Dialog
        className={classes.modalStyles}
        open={open}
        onClose={handleClose}
      >
        <Box my={5}>
          <DialogActions>
              <Button onClick={handleClose} disableElevation autoFocus className={classes.closeButton}>
                <CloseIcon/>
              </Button>
          </DialogActions>
          <DialogTitle className={classes.titleStyles}>Golf Course Map</DialogTitle>
          <DialogContent>
            <Box textAlign='center'>
              <DialogContentText>
                <Image width="140" height="330" layout="fixed" src={imgSource} alt='alt text' />
              </DialogContentText>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </Box>
  );
}

export default AerialGolfHole;
